import { render } from "./numeriUtili.vue?vue&type=template&id=0c4c7b3a&bindings={\"navigate\":\"props\"}"
import script from "./numeriUtili.vue?vue&type=script&lang=js"
export * from "./numeriUtili.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./numeriUtili.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script